const defaultSsoUrl = `${window.location.protocol}//${window.location.hostname}:7000`;
const SSO_URL = process.env.REACT_APP_SSO_URL || defaultSsoUrl;

export async function redirectWithSsoCode({ targetUrl, token, hashRoute = false, next = "" }) {
  const authToken = token || localStorage.getItem("hrms_token") || localStorage.getItem("crm_token") || localStorage.getItem("company_chat_token");
  if (!authToken) throw new Error("Missing sign-in token");

  const res = await fetch(`${SSO_URL.replace(/\/$/, "")}/sso/code`, {
    method: "POST",
    credentials: "include",
    headers: { Authorization: `Bearer ${authToken}` },
  });
  const text = await res.text();
  let data = {};
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    throw new Error("SSO service returned an unexpected response");
  }
  if (!res.ok) throw new Error(data.error || "Could not create SSO code");

  const params = new URLSearchParams({ sso_code: data.sso_code });
  if (next) params.set("next", next);
  const base = targetUrl.replace(/\/$/, "");
  window.location.href = hashRoute ? `${base}/#/sso?${params}` : `${base}/sso?${params}`;
}
